// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_1TXCp","cardBtn":"index_cardBtn_1UjvF","tabs":"index_tabs_2vriF"};